module.exports = __webpack_public_path__ + "img/icon_location_active.944852d2.png";